import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { acceptOrderThunk } from "./ordersSlice";

// Thunk to process a single order
export const processQueuedOrder = createAsyncThunk(
  "orderQueue/processQueuedOrder",
  async (order, { dispatch, getState }) => {
    try {
      console.log("processQueuedOrder");
      const state = getState().orderQueue;
      const now = Date.now();

      // Filter out expired processed orders (older than 3 minutes)
      const validProcessedOrders = state.processedOrders.filter(
        (processedOrder) =>
          now - new Date(processedOrder.preparation_start).getTime() <=
          5 * 60 * 1000
      );

      // Check if the current order has already been processed
      const isAlreadyProcessed = validProcessedOrders.some(
        (processedOrder) => processedOrder.id === order.order_id
      );

      if (isAlreadyProcessed) {
        console.log(`Order ${order.order_id} has already been processed.`);
        return null;
      }

      // Dispatch the accept order thunk
      await dispatch(
        acceptOrderThunk({
          order,
          isAutoAccept: getState().orders.autoAcceptOrders,
          shouldPrint: order.should_print_auto_accept,
        })
      );

      return order;
    } catch (error) {
      console.error("Error processing order:", error);
      throw error;
    }
  }
);

const orderQueueSlice = createSlice({
  name: "orderQueue",
  initialState: {
    queue: [],
    isProcessing: false,
    processedOrders: [],
  },
  reducers: {
    addToQueue: (state, action) => {
      state.queue.push(action.payload);
    },
    startProcessing: (state) => {
      state.isProcessing = true;
    },
    finishProcessing: (state) => {
      const now = Date.now();

      // Remove expired processed orders
      state.processedOrders = state.processedOrders.filter(
        (processedOrder) =>
          now - new Date(processedOrder.preparation_start).getTime() <=
          3 * 60 * 1000
      );

      if (state.queue.length > 0) {
        const processedOrder = state.queue[0];
        state.processedOrders.push({
          id: processedOrder.order_id,
          preparation_start: new Date().toISOString(),
        });
        state.queue.shift();
      }

      state.isProcessing = false;
    },
    failProcessing: (state) => {
      // On failure: stop processing but keep the order in the queue for retry
      state.isProcessing = false;
    },
    clearQueue: (state) => {
      state.queue = [];
      state.isProcessing = false;
    },
  },
});

export const {
  addToQueue,
  startProcessing,
  finishProcessing,
  failProcessing,
  clearQueue,
} = orderQueueSlice.actions;

export default orderQueueSlice.reducer;
